import { render, staticRenderFns } from "./new-email.vue?vue&type=template&id=5bd1c628"
import script from "./new-email.vue?vue&type=script&lang=js"
export * from "./new-email.vue?vue&type=script&lang=js"
import style0 from "./new-email.vue?vue&type=style&index=0&id=5bd1c628&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports